import React from 'react';
// import { Helmet } from 'react-helmet-async';
// import './PolicyPages.css';

// const someDefinedVariable = "Privacy Policy | Secure Digital Signatures & Document Protection – DocuSafe";

const PrivacyPolicy = () => {
    return (
        <>
            {/* <Helmet>
                <title>{someDefinedVariable || "Default Title"}</title>
                <meta name='description' content='Read the Privacy Policy of DocuSafe to understand how we protect your personal data with secure digital signatures, GDPR-compliant e-signatures, and AI-powered document security. Your privacy matters—learn more about our encryption, compliance, and data protection.' />
                <meta name='keywords' content='privacy policy, secure digital signatures, e-signature security, GDPR compliance, document protection, AI-powered security, electronic signature privacy, data encryption policy, online document signing, cybersecurity for documents, digital contracts safety, electronic document security, secure file signing, privacy compliance, online agreement security' />
            </Helmet> */}
            <section className="container">
                <div className="container">
                    <div className="guest-policy-section mt-2">
                        <h6 className="policy-subtitle">Introduction</h6>
                        <div>
                            <p className="guest-policy-text">
                                Your privacy is important to us at <strong>DocuSafe</strong> and its e-signature platform, SignEase.ai. This Privacy Policy outlines how we collect, use, and protect your personal information when you use our services.
                            </p>
                            <p className="guest-policy-text">
                                This policy complies with applicable data protection laws, including the General Data Protection Regulation (GDPR) and other relevant global standards.
                            </p>
                            <p className="guest-policy-text">
                                For any questions or concerns, please contact us at <a href="mailto:support@docusafe.ai" className="policy-link">support@docusafe.ai</a> or by <strong>writing to Redfox Ventures Pte. Ltd., 200 Jalan Sultan, #11-01, Textile Centre, Singapore 199018.</strong>
                            </p>
                        </div>
                    </div>

                    <ul className="guest-policy-list">
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((section) => (
                            <li key={section} className="guest-policy-list-item">
                                <div className="guest-policy-section">
                                    <h6 className="policy-subtitle">
                                        {section}. {getSectionTitle(section)}
                                    </h6>
                                    {renderSectionContent(section)}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
        </>
    );
};

const getSectionTitle = (section) => {
    const titles = {
        1: "Information We Collect",
        2: "Use of Information",
        3: "Data Sharing",
        4: "Data Retention",
        5: "Your Rights",
        6: "Security Measures",
        7: "Cookies and Tracking",
        8: "International Data Transfers",
        9: "Updates to the Privacy Policy"
    };
    return titles[section];
};

const renderSectionContent = (section) => {
    const content = {
        1: (
            <ul className="guest-policy-list">
                <li>
                    <p className="policy-card-title">1.1 Information Provided by Customers</p>
                    <div>
                        <p className="guest-policy-text">We may collect and process the following data:</p>
                        <ul className="guest-policy-list">
                            <li className="guest-policy-text">Registration details, including name, email, company information, and phone number.</li>
                            <li className="guest-policy-text">Documents, files, and metadata uploaded to the platform.</li>
                            <li className="guest-policy-text">Communications and interactions with our support team.</li>
                        </ul>
                    </div>
                </li>
                <li>
                    <p className="policy-card-title">1.2 Information Collected Automatically</p>
                    <div>
                        <p className="guest-policy-text">When using the platform, we may automatically collect:</p>
                        <ul className="guest-policy-list">
                            <li className="guest-policy-text">IP address, browser type, operating system, and usage data.</li>
                            <li className="guest-policy-text">Device identifiers and analytics information to improve platform performance.</li>
                        </ul>
                    </div>
                </li>
                <li>
                    <p className="policy-card-title">1.3 Third-Party Data</p>
                    <div>
                        <ul className="guest-policy-list">
                            <li className="guest-policy-text">If you provide third-party information (e.g., requesting an e-signature from another individual), you confirm that you have obtained consent to share their data with us.</li>
                        </ul>
                    </div>
                </li>
            </ul>
        ),
        2: (
            <ul className="guest-policy-list">
                <li>
                    <p className="policy-card-title">2.1 Purpose of Processing</p>
                    <div>
                        <p className="guest-policy-text">Your personal data is used for the following purposes:</p>
                        <ul className="guest-policy-list">
                            <li className="guest-policy-text">To provide our services, including document storage, e-signature processing, and workflow management.</li>
                            <li className="guest-policy-text">To communicate with you about platform updates, maintenance, and support.</li>
                            <li className="guest-policy-text">To improve our services based on usage analytics and feedback.</li>
                        </ul>
                    </div>
                </li>
                <li>
                    <p className="policy-card-title">2.2 Legal Basis for Processing</p>
                    <div>
                        <p className="guest-policy-text">Our use of your personal data is based on:</p>
                        <ul className="guest-policy-list">
                            <li className="guest-policy-text"><b>Performance of a Contract:</b> Necessary to deliver our services.</li>
                            <li className="guest-policy-text"><b>Legitimate Interests:</b> To enhance and secure the platform.</li>
                            <li className="guest-policy-text"><b>Consent:</b> Where required, such as for marketing communications.</li>
                        </ul>
                    </div>
                </li>
            </ul>
        ),
        3: (
            <ul className="guest-policy-list">
                <li>
                    <p className="policy-card-title">3.1 We do not sell your personal data. However, we may share information with:</p>
                    <div>
                        <ul className="guest-policy-list">
                            <li className="guest-policy-text"><b>Service Providers:</b> Third-party vendors that assist in delivering our services (e.g., AWS for cloud hosting).</li>
                            <li className="guest-policy-text"><b>Legal Authorities:</b> When required to comply with legal obligations or enforce our terms.</li>
                        </ul>
                    </div>
                </li>
            </ul>
        ),
        4: (
            <ul className="guest-policy-list">
                <li>
                    <p className="policy-card-title">4.1 Retention Periods</p>
                    <div>
                        <ul className="guest-policy-list">
                            <li className="guest-policy-text">We retain your data for as long as your account is active or as necessary to fulfill our contractual obligations.</li>
                        </ul>
                    </div>
                </li>
                <li>
                    <p className="policy-card-title">4.2 Deletion of Data</p>
                    <div>
                        <ul className="guest-policy-list">
                            <li className="guest-policy-text">Upon termination of your account, we delete all data within 30 days unless required to retain it for legal or compliance purposes.</li>
                        </ul>
                    </div>
                </li>
            </ul>
        ),
        5: (
            <ul className="guest-policy-list">
                <li>
                    <p className="policy-card-title">5.1 Under applicable laws, you have the following rights:</p>
                    <div>
                        <ul className="guest-policy-list">
                            <li className="guest-policy-text"><b>Access:</b> Request a copy of your personal data.</li>
                            <li className="guest-policy-text"><b>Correction:</b> Update or correct inaccuracies in your data.</li>
                            <li className="guest-policy-text"><b>Erasure:</b> Request deletion of your data.</li>
                            <li className="guest-policy-text"><b>Objection:</b> Object to data processing based on legitimate interests</li>
                            <li className="guest-policy-text"><b>Data Portability:</b> Request transfer of your data to another service provider.</li>
                        </ul>
                    </div>
                </li>
                <li>
                    <div>
                        <p className="guest-policy-text">To exercise your rights, contact <a href="mailto:support@docusafe.ai" className="policy-link">support@docusafe.ai</a>.</p>
                    </div>
                </li>
            </ul>
        ),
        6: (
            <ul className="guest-policy-list">
                <li>
                    <p className="policy-card-title">6.1 Encryption</p>
                    <div>
                        <div>
                            <ul className="guest-policy-list">
                                <li className="guest-policy-text">All data is encrypted in transit and at rest using industry-standard protocols (e.g., TLS 1.2 and AES-256).</li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li>
                    <p className="policy-card-title">6.2 Access Control</p>
                    <div>
                        <ul className="guest-policy-list">
                            <li className="guest-policy-text">We implement multi-factor authentication and role-based permissions to limit access to sensitive data.</li>
                        </ul>
                    </div>
                </li>
                <li>
                    <p className="policy-card-title">6.3 Monitoring</p>
                    <div>
                        <ul className="guest-policy-list">
                            <li className="guest-policy-text">Our systems are monitored 24/7 to detect and prevent unauthorized access or breaches.</li>
                        </ul>
                    </div>
                </li>
            </ul>
        ),
        7: (
            <ul className="guest-policy-list">
                <li>
                    <p className="policy-card-title">7.1 Use of Cookies</p>
                    <div>
                        <ul className="guest-policy-list">
                            <li className="guest-policy-text">We use cookies to enhance user experience and analyze platform usage.</li>
                        </ul>
                    </div>
                </li>
                <li>
                    <p className="policy-card-title">7.2 Managing Cookies</p>
                    <div>
                        <ul className="guest-policy-list">
                            <li className="guest-policy-text">You can disable cookies via your browser settings, but doing so may limit platform functionality.</li>
                        </ul>
                    </div>
                </li>
            </ul>
        ),
        8: (
            <p className="guest-policy-text">
                As a Singapore-based company, your data may be transferred and stored in locations outside your country of residence. These transfers comply with applicable data protection laws and safeguards.
            </p>
        ),
        9: (
            <p className="guest-policy-text">
                This policy may be updated periodically to reflect changes in our practices or legal requirements. Customers will be notified of significant changes via email or platform notifications.
            </p>
        )
    };
    return content[section];
};

export default PrivacyPolicy;
